import root from './root';
import loading from './loading';
import modal from './modal';
import sidebar from './sidebar';
import tour from './tour';
import viewport from './viewport';
import tooltip from './tooltip';

export default {
	// namespaced: true,
	modules: {
		root, loading, modal, sidebar, tour, viewport, tooltip
	}
}
